var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 11.75c-.23 0-.44-.1-.58-.28a.749.749 0 0 1-.15-.63l1.13-5.4c.37-1.75 1.12-3.36 4.09-3.36h7.03c2.97 0 3.72 1.62 4.09 3.36l1.13 5.41c.05.22-.01.45-.15.63-.15.17-.36.27-.59.27H4zm15.07-1.5-.94-4.5c-.28-1.31-.61-2.17-2.62-2.17H8.49c-2.01 0-2.34.86-2.62 2.17l-.95 4.5h14.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.08 22.75c-1.62 0-1.93-.93-2.13-1.54l-.2-.6c-.26-.76-.29-.86-1.19-.86H9.44c-.9 0-.96.17-1.19.86l-.2.6c-.21.62-.51 1.54-2.13 1.54H4.04c-.79 0-1.55-.33-2.08-.91-.52-.57-.77-1.33-.7-2.09l.56-6.09c.15-1.65.59-3.41 3.8-3.41h12.76c3.21 0 3.64 1.76 3.8 3.41l.56 6.09c.07.76-.18 1.52-.7 2.09-.53.58-1.29.91-2.08.91h-1.88zm-3.52-4.5c1.82 0 2.25.81 2.61 1.87l.21.62c.17.51.17.52.71.52h1.88c.37 0 .72-.15.97-.42.24-.26.35-.59.32-.94l-.56-6.09c-.13-1.35-.29-2.05-2.3-2.05H5.62c-2.02 0-2.18.7-2.3 2.05l-.56 6.09c-.03.35.08.68.32.94.24.27.6.42.97.42h1.88c.54 0 .54-.01.71-.51l.2-.61c.25-.8.62-1.89 2.6-1.89h5.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1c.41 0 .75.34.75.75s-.34.75-.75.75H3zM20 8.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1c.41 0 .75.34.75.75s-.34.75-.75.75h-1zM11.25 5V3c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75h-3zM6 15.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75H6zM15 15.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75h-3z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCar);
export default __webpack_public_path__ + "static/media/vuesax-outline-car.73c761342e6fc86a58199c918bbf5b42.svg";
export { ForwardRef as ReactComponent };